import React from "react";
import { Modal, Button } from "antd";

const ModalWindow = ({
  handleSubmit,
  handleCancel,
  handleReset,
  visible,
  title,
  children,
  cancelTextButton = "Отмена",
  submitTextButton = "Ок",
  footer = [
    <Button key="back" onClick={handleReset}>
      {cancelTextButton}
    </Button>,
    <Button key="submit" type="primary" onClick={handleSubmit}>
      {submitTextButton}
    </Button>,
  ],
}) => (
  <Modal
    title={title}
    visible={visible}
    onCancel={handleCancel}
    footer={footer}
  >
    {children}
  </Modal>
);

export default ModalWindow;
